import React from 'react';
import BagIcon from 'assets/figmaexport/icons/Bag.svg?react';
import AccessoriesBabyIcon from 'assets/figmaexport/icons/Accessories_Baby.svg?react';
import BeautySetIcon from 'assets/figmaexport/icons/Beauty_Set.svg?react';
import CarFrontIcon from 'assets/figmaexport/icons/Automotive.svg?react';
import BackpackIcon from 'assets/figmaexport/icons/Backpack.svg?react';
import ShoulderBagIcon from 'assets/figmaexport/icons/Shoulder_Bag.svg?react';
import SportsbagIcon from 'assets/figmaexport/icons/Sportsbag.svg?react';
import SkincareIcon from 'assets/figmaexport/icons/Skincare.svg?react';
import BeltsIcon from 'assets/figmaexport/icons/Belt.svg?react';
import BootsIcon from 'assets/figmaexport/icons/Boots.svg?react';
import BraIcon from 'assets/figmaexport/icons/Bra.svg?react';
import BraceletIcon from 'assets/figmaexport/icons/Bracelet.svg?react';
import BlouseIcon from 'assets/figmaexport/icons/Blouse.svg?react';
import CoatIcon from 'assets/figmaexport/icons/Coat.svg?react';
import CombinationClothingIcon from 'assets/figmaexport/icons/Combination_Clothing.svg?react';
import DressIcon from 'assets/figmaexport/icons/Dress.svg?react';
import EarringIcon from 'assets/figmaexport/icons/Earring.svg?react';
import ElectronicsIcon from 'assets/figmaexport/icons/Smartwatch.svg?react';
import FlatShoesIcon from 'assets/figmaexport/icons/Loafers.svg?react';
import GlovesIcon from 'assets/figmaexport/icons/Glove.svg?react';
import HatIcon from 'assets/figmaexport/icons/Hat.svg?react';
import HighHeelsIcon from 'assets/figmaexport/icons/Shoes_High_Heels.svg?react';
import DIYIcon from 'assets/figmaexport/icons/Box.svg?react';
import JacketBlazerIcon from 'assets/figmaexport/icons/Cardigan_Men.svg?react';
import JeansIcon from 'assets/figmaexport/icons/Jeans.svg?react';
import JewelleryIcon from 'assets/figmaexport/icons/Diamond.svg?react';
import JewellerySetsIcon from 'assets/figmaexport/icons/Jewelry_Set.svg?react';
import JewelleryWatchesIcon from 'assets/figmaexport/icons/Necklace_Men.svg?react';
import JumpsuitIcon from 'assets/figmaexport/icons/Jumpsuit.svg?react';
import KnitwearIcon from 'assets/figmaexport/icons/Knitwear.svg?react';
import LoungewearIcon from 'assets/figmaexport/icons/Loungewear.svg?react';
import NecklacesIcon from 'assets/figmaexport/icons/Necklace_Women.svg?react';
import PantsIcon from 'assets/figmaexport/icons/Trousers.svg?react';
import SandalsIcon from 'assets/figmaexport/icons/Sandals.svg?react';
import ScarvesIcon from 'assets/figmaexport/icons/Scarf.svg?react';
import ShirtIcon from 'assets/figmaexport/icons/Shirt.svg?react';
import SkirtIcon from 'assets/figmaexport/icons/Skirt.svg?react';
import SneakersIcon from 'assets/figmaexport/icons/Sneakers.svg?react';
import SocksIcon from 'assets/figmaexport/icons/Socks.svg?react';
import SportsEquipmentIcon from 'assets/figmaexport/icons/Sports_Equipment.svg?react';
import SportswearIcon from 'assets/figmaexport/icons/Sportswear.svg?react';
import SuitsIcon from 'assets/figmaexport/icons/Suit.svg?react';
import SweatshirtIcon from 'assets/figmaexport/icons/Sweatshirt.svg?react';
import SwimwearIcon from 'assets/figmaexport/icons/Swimwear_Women.svg?react';
import RingsIcon from 'assets/figmaexport/icons/Ring.svg?react';
import ShirtBlouseIcon from 'assets/figmaexport/icons/Shirt_Blouse.svg?react';
import ShortsIcon from 'assets/figmaexport/icons/Shorts_Women.svg?react';
import TrouserPantsIcon from 'assets/figmaexport/icons/Shorts_Men.svg?react';
import TShirtIcon from 'assets/figmaexport/icons/T_Shirt.svg?react';
import UnderpantsIcon from 'assets/figmaexport/icons/Underpants.svg?react';
import UnderwearLingerieIcon from 'assets/figmaexport/icons/Underwear_Multipack_Women.svg?react';
import UndershirtsIcon from 'assets/figmaexport/icons/Undershirt.svg?react';
import UnderwearIcon from 'assets/figmaexport/icons/Underwear.svg?react';
import UnknownIcon from 'assets/figmaexport/icons/Hanger.svg?react';
import VestIcon from 'assets/figmaexport/icons/Vest.svg?react';
import WatchesIcon from 'assets/figmaexport/icons/Watch.svg?react';
import ShoesIcon from 'assets/figmaexport/icons/Shoes_Business_Men.svg?react';
import SpecialItemIcon from 'assets/figmaexport/icons/Special_Item.svg?react';
import TextilesIcon from 'assets/figmaexport/icons/Textiles.svg?react';
import OtherEquipmentIcon from 'assets/figmaexport/icons/Tag.svg?react';
import BallerinasIcon from 'assets/figmaexport/icons/Ballerinas.svg?react';
import BathrobeIcon from 'assets/figmaexport/icons/Bathrobe.svg?react';
import BeachShoesIcon from 'assets/figmaexport/icons/Beach_Shoes.svg?react';
import BeachTrouserIcon from 'assets/figmaexport/icons/Swimwear_Men.svg?react';
import BikiniIcon from 'assets/figmaexport/icons/Swimwear_Women.svg?react';
import BusinessShoesIcon from 'assets/figmaexport/icons/Shoes_Business_Men.svg?react';
import DentalCareIcon from 'assets/figmaexport/icons/Dental_Care.svg?react';
import FragranceIcon from 'assets/figmaexport/icons/Fragrance.svg?react';
import GiftIcon from 'assets/figmaexport/icons/Gift.svg?react';
import HairCareIcon from 'assets/figmaexport/icons/Hair_Care.svg?react';
import HouseShoesIcon from 'assets/figmaexport/icons/House_Shoes.svg?react';
import KitchenIcon from 'assets/figmaexport/icons/Kitchen.svg?react';
import LaceUpShoesIcon from 'assets/figmaexport/icons/Lace_Up_Shoes.svg?react';
import LoafersIcon from 'assets/figmaexport/icons/Loafers.svg?react';
import MakeUpIcon from 'assets/figmaexport/icons/Make_Up.svg?react';
import MulesIcon from 'assets/figmaexport/icons/Mules.svg?react';
import NailsIcon from 'assets/figmaexport/icons/Nails.svg?react';
import NightwearIcon from 'assets/figmaexport/icons/Nightwear.svg?react';
import OpenShoesIcon from 'assets/figmaexport/icons/Open_Shoes.svg?react';
import OutdoorShoesIcon from 'assets/figmaexport/icons/Outdoor_Shoes.svg?react';
import PumpsIcon from 'assets/figmaexport/icons/Pumps.svg?react';
import ShoeAccessoriesIcon from 'assets/figmaexport/icons/Shoe_Accessories.svg?react';
import SportsShoesIcon from 'assets/figmaexport/icons/Sport_Shoes.svg?react';
import SuncareIcon from 'assets/figmaexport/icons/Suncare.svg?react';
import BathIcon from 'assets/figmaexport/icons/Bathroom.svg?react';
import BeachAccessoriesIcon from 'assets/figmaexport/icons/Beach_Accessoires.svg?react';
import BeachShirtIcon from 'assets/figmaexport/icons/Beach_Shirt.svg?react';
import BridalShoesIcon from 'assets/figmaexport/icons/Bridal_Shoes.svg?react';
import DecorationIcon from 'assets/figmaexport/icons/Decoration.svg?react';
import FurnitureIcon from 'assets/figmaexport/icons/Furniture.svg?react';
import HomeAndLivingIcon from 'assets/figmaexport/icons/Home_And_Living.svg?react';
import LampIcon from 'assets/figmaexport/icons/Lamp.svg?react';
import BeautyIcon from 'assets/figmaexport/icons/Beauty.svg?react';
import AnkleBootsIcon from 'assets/figmaexport/icons/Ankle_Boots.svg?react';
import TieIcon from 'assets/figmaexport/icons/Tie.svg?react';
import BodyCareIcon from 'assets/figmaexport/icons/Bodycare.svg?react';
import DressJumpsuitIcon from 'assets/figmaexport/icons/Business_Dress.svg?react';
import SuitsMatchingSetsIcon from 'assets/figmaexport/icons/Matching_Sets.svg?react';
import ApparelIcon from 'assets/figmaexport/icons/Clothing.svg?react';

const categoryIcons: Record<string, React.FC> = {
  accessory: BagIcon,
  all_accessories: BeautySetIcon,
  ankle_boots: AnkleBootsIcon,
  apparel: ApparelIcon,
  automotive: CarFrontIcon,
  baby_accessory: AccessoriesBabyIcon,
  backpacks: BackpackIcon,
  ballerinas: BallerinasIcon,
  bags: ShoulderBagIcon,
  bags_cases: SportsbagIcon,
  bath: BathIcon,
  bathrobes: BathrobeIcon,
  beach_accessories: BeachAccessoriesIcon,
  beach_shirt: BeachShirtIcon,
  beach_shoes: BeachShoesIcon,
  beach_trouser: BeachTrouserIcon,
  beauty: BeautyIcon,
  belts: BeltsIcon,
  bikini: BikiniIcon,
  blouses: BlouseIcon,
  body_care_products: BodyCareIcon,
  boots: BootsIcon,
  bra: BraIcon,
  bracelets: BraceletIcon,
  bridal_shoes: BridalShoesIcon,
  business_shoes: BusinessShoesIcon,
  coat: CoatIcon,
  combination_clothing: CombinationClothingIcon,
  decoration: DecorationIcon,
  dental_care: DentalCareIcon,
  dress: DressIcon,
  dresses_jumpsuits: DressJumpsuitIcon,
  earrings: EarringIcon,
  electronics: ElectronicsIcon,
  flat_shoes: FlatShoesIcon,
  fragrances: FragranceIcon,
  furniture: FurnitureIcon,
  gifts: GiftIcon,
  gloves: GlovesIcon,
  hair_care: HairCareIcon,
  hats: HatIcon,
  high_heels: HighHeelsIcon,
  home_and_living: HomeAndLivingIcon,
  home_diy: DIYIcon,
  house_shoes: HouseShoesIcon,
  jacket_blazer: JacketBlazerIcon,
  jeans: JeansIcon,
  jewellery: JewelleryIcon,
  jewellery_sets: JewellerySetsIcon,
  jewellery_watches: JewelleryWatchesIcon,
  jumpsuit: JumpsuitIcon,
  kitchen: KitchenIcon,
  knitwear: KnitwearIcon,
  lace_up_shoes: LaceUpShoesIcon,
  lamps: LampIcon,
  loafers: LoafersIcon,
  loungewear: LoungewearIcon,
  make_up: MakeUpIcon,
  mules: MulesIcon,
  nails: NailsIcon,
  necklaces: NecklacesIcon,
  nightwear: NightwearIcon,
  open_shoes: OpenShoesIcon,
  other_equipment: OtherEquipmentIcon,
  outdoor_shoes: OutdoorShoesIcon,
  pants: PantsIcon,
  pumps: PumpsIcon,
  rings: RingsIcon,
  sandals: SandalsIcon,
  scarves: ScarvesIcon,
  shirt: ShirtIcon,
  shirt_blouses: ShirtBlouseIcon,
  shoe_accessories: ShoeAccessoriesIcon,
  shoes: ShoesIcon,
  shorts: ShortsIcon,
  skincare: SkincareIcon,
  skirt: SkirtIcon,
  sneaker: SneakersIcon,
  socks_tights: SocksIcon,
  special_items: SpecialItemIcon,
  sport_equipment: SportsEquipmentIcon,
  sports_shoes: SportsShoesIcon,
  sportswear: SportswearIcon,
  suits: SuitsIcon,
  suits_matchingsets: SuitsMatchingSetsIcon,
  sun_care: SuncareIcon,
  sweatshirt_hoodie: SweatshirtIcon,
  swimwear: SwimwearIcon,
  t_shirt_top: TShirtIcon,
  textiles: TextilesIcon,
  ties: TieIcon,
  trousers_pants: TrouserPantsIcon,
  underpant: UnderpantsIcon,
  undershirt: UndershirtsIcon,
  underwear: UnderwearIcon,
  underwear_lingerie: UnderwearLingerieIcon,
  unknown: UnknownIcon,
  vest: VestIcon,
  watches: WatchesIcon,
};

/**
 * Finds and returns the icon associated with the given category.
 *
 * @param category name of the category for which to find an icon
 * @param size target size of the icon
 * @return a React element containing the desired icon if found.
 * Otherwise, the icon belonging to category 'unknown' is returned.
 */
export function findIconForCategory(category: string, size: number): React.ReactElement {
  const props: Record<string, number | string> = { size };
  if (category === 'automotive') {
    props.strokeWidth = 1.5;
  }
  return React.createElement(categoryIcons[category] ?? categoryIcons.unknown, props);
}
